import React from 'react';
import FormulairesContact from '../components/FormulairesContact';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';


function App() {
  return (
    <div className="App">
      <FormulairesContact />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
